export const licitaciones2024 = [
  {
    titulo: "Convocatoria 01-2024",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N1-2024",
      },
      {
        informacionTitulo: "EA-913005999-N2-2024",
      },
      {
        informacionTitulo: "EA-913005999-N3-2024",
      },
    ],
  },
  {
    titulo: "Convocatoria 02-2024",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N4-2024",
      },
      {
        informacionTitulo: "EA-913005999-N5-2024",
      },
    ],
  },
  {
    titulo: "Convocatoria 03-2024",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N6-2024",
      },
    ],
  },
  {
    titulo: "Convocatoria 01-2024 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-01-2024",
      },
    ],
  },
  {
    titulo: "Convocatoria 04-2024",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N7-2024",
      },
    ],
  },
  {
    titulo: "Convocatoria 05-2024",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N8-2024",
      },
    ],
  },
 
];
